import {
  useModalContext,
  WSElementProps,
  WSForm,
  WSModal,
  WSRadioInputGroup
} from "@wingspanhq/fe-component-library";
import { ISubscription } from "@wingspanhq/users";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useUserId } from "../../../query/hooks/helpers";
import { useSubscriptionV3Query } from "../../../query/subscriptions/queries";
import {
  isFeatureIncludedInSubscription,
  WSFrontendFeature
} from "../../../Settings/utils/subscriptionUtils";
import { AddClientForm } from "../AddClientForm/AddClientForm";
import { AddCollaboratorForm } from "../AddCollaboratorForm/AddCollaboratorForm";

type Props = WSElementProps;

export const ADD_CONTACT_MODAL = "ADD_CONTACT_MODAL";

export const AddContactModal: React.FC<Props> = () => {
  const history = useHistory();
  const { closeModal } = useModalContext();
  const [isClientForm, setIsClientForm] = useState(true);
  const userId = useUserId();
  const subscriptionQuery = useSubscriptionV3Query(userId);
  const allowedToCreateCollaborator = isFeatureIncludedInSubscription(
    WSFrontendFeature.InviteAndPayCollaborator,
    subscriptionQuery.data as ISubscription
  );

  return (
    <WSModal name={ADD_CONTACT_MODAL} size="S" title="Add contact">
      {allowedToCreateCollaborator && (
        <>
          <WSForm.Label>Contact type</WSForm.Label>
          <WSRadioInputGroup
            mb="M"
            value={isClientForm ? "client" : "collaborator"}
            name="contactType"
            options={[
              {
                value: "client",
                label: "Client"
              },
              {
                value: "collaborator",
                label: "Collaborator"
              }
            ]}
            onChange={(event: any) => {
              setIsClientForm(event.target.value === "client");
            }}
          />
        </>
      )}

      {isClientForm ? (
        <AddClientForm
          onCancel={() => {
            closeModal(ADD_CONTACT_MODAL);
          }}
          onSuccess={memberClient => {
            closeModal(ADD_CONTACT_MODAL);
            history.push(
              `/member/invoices/contacts/recent-clients/${memberClient.memberClientId}`,
              {
                backPath: "/member/invoices/contacts"
              }
            );
          }}
        />
      ) : (
        <AddCollaboratorForm
          onCancel={() => {
            closeModal(ADD_CONTACT_MODAL);
          }}
          onSuccess={collaborator => {
            closeModal(ADD_CONTACT_MODAL);
            history.push(
              `/member/invoices/contacts/recent-collaborators/${collaborator.collaboratorId}`,
              {
                backPath: "/member/invoices/contacts"
              }
            );
          }}
        />
      )}
    </WSModal>
  );
};
